import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import MessageQuill from "../Message/MessageQuill";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";
import { useCreate } from "../../../Context/CreateContext";

const AddSession = ({ close, status, id, setId, getSessions }) => {
  const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

  const [start, setStart] = useState();
  const [end, setEnd] = useState();
  const [call, setCall] = useState();
  const [description, setDescription] = useState();
  const [session, setSession] = useState({
    id: "",
    session_name: "",
    session_start_time: "",
    session_end_time: "",
    session_description: "",
  });

  const handleModalClose = (e) => {
    e.stopPropagation();
    close(false);
    setSession({
      id: "",
      session_name: "",
      session_start_time: "",
      session_end_time: "",
      session_description: "",
    });
    setStart("");
    setEnd("");
    setId("");
    setDescription("");
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setSession({
      ...session,
      session_start_time: moment(start, "HH:mm:ss jYYYY/jMM/jDD").format(),
    });
  }, [start]);

  useEffect(() => {
    setSession({
      ...session,
      session_end_time: moment(end, "HH:mm:ss jYYYY/jMM/jDD").format(),
    });
  }, [end]);

  useEffect(() => {
    setSession({ ...session, session_description: description });
  }, [description]);

    const submitForm = () => {
        if (id) {
            editSession.reFetch();
            //TODO : clear states
            close();
        } else {
            const formData = new FormData();

      formData.append("bootcamp", bootCamp.id);
      formData.append("session_name", session.session_name);
      formData.append("session_start_time", session.session_start_time);
      formData.append("session_end_time", session.session_end_time);
      formData.append("session_description", description);

      setCall(formData);
      newSession.reFetch();

      setSession({
        id: "",
        session_name: "",
        session_start_time: "",
        session_end_time: "",
        session_description: "",
      });

      setStart();
      setEnd();

      close();
    }
  };

  useEffect(() => {
    if (id) {
      setStart(
        moment(session.session_start_time)
          .locale("fa", { useGregorianParser: true })
          .format("HH:mm:ss YYYY/MM/DD")
      );

      setEnd(
        moment(session.session_end_time)
          .locale("fa", { useGregorianParser: true })
          .format("HH:mm:ss YYYY/MM/DD")
      );
    }
  }, [session]);

  const newSession = useFetch({
    method: "POST",
    url: `BootCampSessionService`,
    noHeader: false,
    caller: getSessions,
    trigger: false,
    data: call,
  });

  const getSessionsId = useFetch({
    method: "GET",
    url: `BootCampSessionService/${id}`,
    noHeader: false,
    trigger: false,
    setter: setSession,
  });

  const editSession = useFetch({
    method: "PATCH",
    url: `BootCampSessionService/${id}`,
    noHeader: false,
    trigger: false,
    caller: getSessions,
    data: session,
  });

  useEffect(() => {
    id && getSessionsId.reFetch();
  }, [id]);

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={handleModalClose}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                {status ? "اطلاعات تکلیف" : "اطلاعات جلسه"}
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    value={session.session_name}
                    onChange={(e) =>
                        setSession({
                            ...session,
                            session_name: e.target.value,
                        })
                    }
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام جلسه*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                />
                <div className="flex justify-around gap-8 mb-[1.6rem]">
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={start}
                        setDate={setStart}
                        message="زمان شروع جلسه را وارد کنید"
                        placeholder="زمان شروع جلسه *"
                        full={true}
                        name="catch_start_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={end}
                        setDate={setEnd}
                        message="زمان پایان جلسه را وارد کنید"
                        placeholder="زمان پایان جلسه *"
                        full={true}
                        name="catch_end_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                </div>

        <MessageQuill
          placeholder="توضیحات *"
          value={session.session_description}
          setValue={setDescription}
        />

        <BtnPrimary
          className=" py-[2rem] px-[6rem] flex mr-auto "
          text={`ثبت ${status ? "تکلیف" : "جلسه"}`}
        />
      </form>
    </div>
  );
};

export default AddSession;
